import { render } from "./StaffManagement.vue?vue&type=template&id=33add77d&scoped=true"
import script from "./StaffManagement.vue?vue&type=script&lang=js"
export * from "./StaffManagement.vue?vue&type=script&lang=js"

import "./StaffManagement.vue?vue&type=style&index=0&id=33add77d&scoped=true&lang=css"

import exportComponent from "/home/cm/project/golinker/admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33add77d"]])

export default __exports__